<app-compose-mail appendTo='body' style="z-index: 9999999;"></app-compose-mail>

<p-table [value]="produits" #dt  [columns]="cols"    [globalFilterFields]="['designation']">
    <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: left">
             <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;" class="btn-def"></button>
            <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF" (click)="exportPdf()" class="btn-def"></button>
         </div>
        <div style="text-align: right">        
            <span *ngIf="dt.filteredValue"> 
  <span style="color: red;"> {{prosuisSum}}</span>
                
                {{dt.filteredValue.length}} / </span>{{dt.totalRecords}} Materiel
 
            <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50"  placeholder="Designation Publicite" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns"  [pSortableColumn]="col.field">
                {{col.header}}    
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>

            
        </tr>
        <tr>
            <th *ngFor="let col of columns"   >
                <input  style="border: none;" type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">   </th>

            
        </tr>
        
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
                {{rowData[col.field]}}
            </td>
        </tr>
    </ng-template>
</p-table>

 